import { Component, OnInit, Input, Output, ViewChild, EventEmitter, AfterViewInit } from '@angular/core';
import { SteppedCalMethodViewModel, CalculationMethodType, CalculationMethod, InflectionCalMethodViewModel, LinearCalMethodViewModel, PolynomialCalMethodViewModel, JDCalMehtodViewModel, MeasurementPointsViewModel, UpdateAllCalculationMethods } from '../../model/measurement-points.model';
import { SteppedCalMethodComponent } from '../stepped-cal-method/stepped-cal-method.component';
import { InflectionCalMethodComponent } from '../inflection-cal-method/inflection-cal-method.component';
import { JdCalMethodComponent } from '../jd-cal-method/jd-cal-method.component';
import { LinearCalMethodComponent } from '../linear-cal-method/linear-cal-method.component';
import { PloynomialCalMethodComponent } from '../ploynomial-cal-method/ploynomial-cal-method.component';
import { MeasurementPonitsService } from '../../services/measurement-points-service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'calculation-method-forms',
  templateUrl: './calculation-method-forms.component.html',
  styleUrls: ['./calculation-method-forms.component.scss']
})
export class CalculationMethodFormsComponent implements OnInit, AfterViewInit {


  @Input() currentlyEditingMethod: CalculationMethod;

  @Output() savedAll = new EventEmitter();

  @Output() savingAllCalculation = new EventEmitter();

  WornCalculationMethodTypeId = 0;

  currentAllCalculationMethodsWithInThisMeasurementPoints: CalculationMethod[] = [];

  BudgetLife = 0;


  @ViewChild('steppedCal')
  steppedCal: SteppedCalMethodComponent;

  @ViewChild('inflectionCal')
  inflectionCal: InflectionCalMethodComponent;

  @ViewChild('ployCal')
  ployCal: PloynomialCalMethodComponent;

  @ViewChild('jdCal')
  jdCal: JdCalMethodComponent;

  @ViewChild('linearCal')
  linearCal: LinearCalMethodComponent;

  steppedCalModel: SteppedCalMethodViewModel;
  inflectionCalModel: InflectionCalMethodViewModel;
  linearCalModel: LinearCalMethodViewModel;
  ployCalModel: PolynomialCalMethodViewModel;
  jdCalModel: JDCalMehtodViewModel;
  editingMeasurementPoint: MeasurementPointsViewModel;
  ngAfterViewInit(): void {

  }

  constructor(
    private _measurementPointsService: MeasurementPonitsService,
    private _loading: LoadingService,
    private _notification: NotificationsService,

  ) { }

  ngOnInit() {
  }



  assignAllCalculationMethods(allCal: CalculationMethod[]) {
    this.currentAllCalculationMethodsWithInThisMeasurementPoints = allCal;
  }
  assignMeasurementPonits(measurementPoints: MeasurementPointsViewModel) {
    this.editingMeasurementPoint = measurementPoints;
  }



  selectMethod(id: number) {
    this.WornCalculationMethodTypeId = id;
    // todo bug!!! with changing the calculation method there might be a bug  test
    // if(this.currentlyEditingMethod.WornCalculationMethodTypeId != +id){
    //   this.currentlyEditingMethod.CalculationMethodId= null;
    // }
    this.currentlyEditingMethod.WornCalculationMethodTypeId = +id;
    switch (+this.WornCalculationMethodTypeId) {
      case CalculationMethodType.STEPPED:
        this.steppedCalModel = this.currentlyEditingMethod as SteppedCalMethodViewModel;
        this.steppedCal.steppedCalMethod = this.steppedCalModel;
        break;

      case CalculationMethodType.Inflection:
        this.inflectionCalModel = this.currentlyEditingMethod as InflectionCalMethodViewModel;
        this.inflectionCal.inflectionCalMethod = this.inflectionCalModel;
        break;

      case CalculationMethodType.Polynomial:
        this.ployCalModel = this.currentlyEditingMethod as PolynomialCalMethodViewModel;
        this.ployCal.ployCalModel = this.ployCalModel;
        break;

      case CalculationMethodType.Linear:
        this.linearCalModel = this.currentlyEditingMethod as LinearCalMethodViewModel;
        // this.linearCal.linearCalModel = this.linearCalModel;
        this.linearCal.setViewModel(this.linearCalModel);
        break;

      case CalculationMethodType.JD:
        this.jdCalModel = this.currentlyEditingMethod as JDCalMehtodViewModel;
        this.jdCal.jdCalMethod = this.jdCalModel;
        break;

      default: {
        break;
      }
    }

  }


  saveAllCalculationMethods() {

    this._loading.startLoading();
    this.savingAllCalculation.emit(true);
    const steppedMethods: SteppedCalMethodViewModel[] = [];
    const inflectionMethods: InflectionCalMethodViewModel[] = [];
    const polyMethods: PolynomialCalMethodViewModel[] = [];
    const JDMethods: JDCalMehtodViewModel[] = [];
    const linearMethods: LinearCalMethodViewModel[] = [];


    this.currentAllCalculationMethodsWithInThisMeasurementPoints.forEach(cal => {
      cal.BugetLife = this.editingMeasurementPoint.BugetLife;
      switch (+cal.WornCalculationMethodTypeId) {
        case CalculationMethodType.STEPPED:
          const stepped = cal as SteppedCalMethodViewModel;
          stepped.CalculationMethodId = +CalculationMethodType.STEPPED;
          steppedMethods.push(stepped);
          break;
        case CalculationMethodType.Inflection:
          const inflection = cal as InflectionCalMethodViewModel;
          inflection.CalculationMethodId = +CalculationMethodType.Inflection;
          inflectionMethods.push(inflection);
          break;
        case CalculationMethodType.Polynomial:
          const ploy = cal as PolynomialCalMethodViewModel;
          ploy.CalculationMethodId = +CalculationMethodType.Polynomial;
          polyMethods.push(ploy);
          break;
        case CalculationMethodType.Linear:
          const lin = cal as LinearCalMethodViewModel;
          lin.CalculationMethodId = +CalculationMethodType.Linear;
          linearMethods.push(lin);
          break;
        case CalculationMethodType.JD:
          const jd = cal as JDCalMehtodViewModel;
          jd.CalculationMethodId = +CalculationMethodType.JD;
          JDMethods.push(jd);
          break;
        default:
          break;
      }
    });

    this.editingMeasurementPoint.CalculationMethods = this.currentAllCalculationMethodsWithInThisMeasurementPoints;

    const model = new UpdateAllCalculationMethods();
    model.SteppedMethods = steppedMethods;
    model.InflectionMethods = inflectionMethods;
    model.JDMethods = JDMethods;
    model.LinearMethods = linearMethods;
    model.PolyMethods = polyMethods;

    console.log(model);
    this._measurementPointsService.updateMeasurementPointsCalculations(model).subscribe(result => {
      this.savedAll.emit(result);
      this._loading.finishedLoading();
    });
  }


  addNewToolToCalculation(newCalculMethod: CalculationMethod) {
    this.changeEditingTool(newCalculMethod);
    this.selectMethod(newCalculMethod.WornCalculationMethodTypeId);
  }



  private changeEditingTool(calculationMethod: CalculationMethod) {
    const findEditingTool = this.currentAllCalculationMethodsWithInThisMeasurementPoints.find(c => c.ToolId === calculationMethod.ToolId);
    if (findEditingTool !== undefined) {
      this.BudgetLife = findEditingTool.BugetLife;
      this.currentlyEditingMethod = findEditingTool;
      this.WornCalculationMethodTypeId = findEditingTool.WornCalculationMethodTypeId;
    }
  }
}




